import React from "react";
import { Route, Switch } from "react-router-dom";
import Jenny from "./pages/Jenny";
import Sivert from "./pages/Sivert";
import Family from "./pages/Family";
import NotFound from "./pages/Notfound";
import WeekScheduleKids from "./pages/WeekScheduleKids";
import WeeklyAllowance from "./pages/WeeklyAllowance";
import ShoppingList from "./pages/ShoppingList";
import Admin from './components/Admin/Admin';
import RopeJumping from './pages/RopeJumping';
import PushUpsContainer from './components/PushUps/PushUpsContainer';

function Routes() {
    return (
        <div className="mainView">
            <Route render={(props)=>(
                    <Switch>
                        <Route path="/" exact component={Family}/>
                        <Route path="/jenny" component={Jenny}/>
                        <Route path="/sivert" component={Sivert}/>
                        <Route path="/weekschedulekids" component={WeekScheduleKids}/>
                        <Route path="/weeklyAllowance" component={WeeklyAllowance}/>
                        <Route path="/exercise" component={RopeJumping}/>
                        <Route path="/pushups" component={PushUpsContainer}/>
                        <Route path="/shoppingList" component={ShoppingList}/>
                        <Route path="/admin" component={Admin}/>
                        <Route component={NotFound}/>
                    </Switch>
            )}/>
        </div>
    )
}

export default Routes;